import styled, { css } from "styled-components";
import { Size } from "./types";

export const StyledLabel = styled.div<{ size: Size; disabled?: boolean }>`
	font-weight: 500;
	white-space: nowrap;
	opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};

	${({ size }) => {
		switch (size) {
			case "sm":
				return css`
					font-size: 0.75rem;
					line-height: 1rem;
				`;
			case "md":
				return css`
					font-size: 1rem;
					line-height: 1.25rem;
				`;
			case "lg":
				return css`
					font-size: 1.125rem;
					line-height: 1.5rem;
				`;
			default:
				return "";
		}
	}}
`;
